(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // Use querySelectorAll to handle each slider independently
  const mainSliders = document.querySelectorAll('.is-main-slider [data-slider="true"]');
  
  mainSliders.forEach((slider) => {
    const slides = slider.querySelectorAll('.hero-slide');
    
    // Safety check: if only one slide, just make it active and stop
    if (slides.length < 2) {
      if (slides[0]) slides[0].classList.add('is-active');
      return;
    }

    let current = 0;

    // Initialize: ensure slide 1 is active, others are hidden
    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === 0);
    });

    // Start the transition loop
    setInterval(() => {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }, 12000); // 12 seconds per slide
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
